import { z } from "zod";

export const updateClientSchema = z.object({
  name: z.string().min(2).optional(),
  phone: z.string().optional(),
}).strict();
